<!--
  AI:
  Status: "confirmed"
  Type: Component
  SubType: CrudIntegration
  Reason: Action button that opens the metadata-driven vs.Visit create dialog.
    No manual form — the dialog renders the backend-driven VisitForm.
-->
@if (compact) {
    <p-button
            [icon]="'fa-regular fa-map-location-dot'"
            [text]="true"
            [pTooltip]="label"
            (click)="openVisitDialog()">
    </p-button>
} @else {
    <p-button
            [label]="label"
            [icon]="'fa-regular fa-map-location-dot'"
            [pTooltip]="label"
            (click)="openVisitDialog()">
    </p-button>
}
